import type { StrictColor } from "@similarweb/styles";
import { colorsPalettes } from "@similarweb/styles";

import { LeadPriorityScore } from "app/pages/sales-intelligence/domain/leads/types/lead-priority";

type ScoreTypeConfig = {
    readonly labelKey: string;
    readonly colors: readonly StrictColor[];
    readonly heights: readonly number[];
    readonly textColor: StrictColor;
};

export const LEAD_SCORE_TYPE_CONFIG: Record<LeadPriorityScore, ScoreTypeConfig> = {
    [LeadPriorityScore.High]: {
        labelKey: "grow.lead_generator.exist.table.column.leads_priority.chip.high",
        colors: [colorsPalettes.torquoise[400], colorsPalettes.torquoise[400], colorsPalettes.torquoise[400]],
        heights: [5, 9, 13],
        textColor: colorsPalettes.carbon[400],
    },
    [LeadPriorityScore.Medium]: {
        labelKey: "grow.lead_generator.exist.table.column.leads_priority.chip.medium-short",
        colors: [colorsPalettes.yellow[400], colorsPalettes.yellow[400], colorsPalettes.carbon[50]],
        heights: [5, 9, 13],
        textColor: colorsPalettes.carbon[400],
    },
    [LeadPriorityScore.Low]: {
        labelKey: "grow.lead_generator.exist.table.column.leads_priority.chip.low",
        colors: [colorsPalettes.sky[500], colorsPalettes.carbon[50], colorsPalettes.carbon[50]],
        heights: [5, 9, 13],
        textColor: colorsPalettes.carbon[400],
    },
    [LeadPriorityScore.Unlock]: {
        labelKey: "grow.lead_generator.exist.table.column.leads_priority.chip.unlock-score",
        colors: [],
        heights: [],
        textColor: colorsPalettes.carbon[400],
    },
    [LeadPriorityScore.NoScore]: {
        labelKey: "grow.lead_generator.exist.table.column.leads_priority.chip.no-score",
        colors: [],
        heights: [],
        textColor: colorsPalettes.carbon[400],
    },
};
